module.exports = __webpack_public_path__ + "static/media/CreateNewCard.50eaab1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/CreateNewCard.png
// module id = 261
// module chunks = 0